import React, { useEffect, useState } from "react";
import { getCsrfToken } from "../../../../public/api/authApi";
import { GlobalModal } from "../../../../global/GlobalModal";
import { GlobalButton } from "../../../../global/forms/GlobalFormFields";
import { cancelSchedule } from "../../api/schedulesApi";
import { ensureCsrfToken } from "../../utils/scheduleHelpers";

export default function CancelScheduleModal({ schedule, onClose, onSuccess, onError }) {
  const open = Boolean(schedule?.id);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) setLoading(false);
  }, [open, schedule?.id]);

  const handleConfirm = async () => {
    const id = Number(schedule?.id);
    if (!Number.isFinite(id) || id <= 0) return;

    setLoading(true);
    try {
      const csrfToken = await ensureCsrfToken(getCsrfToken);
      const res = await cancelSchedule(id, csrfToken);
      onClose?.();
      onSuccess?.(res?.message || "Schedule cancelled successfully");
    } catch (err) {
      onClose?.();
      onError?.(err?.message || "Failed to cancel schedule");
    } finally {
      setLoading(false);
    }
  };

  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      title="Cancel schedule"
      size="sm"
      closeOnBackdrop={!loading}
      footer={
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "flex-end", width: "100%" }}>
          <GlobalButton variant="ghost" onClick={onClose} disabled={loading}>
            Keep schedule
          </GlobalButton>
          <GlobalButton variant="danger" onClick={handleConfirm} disabled={loading}>
            {loading ? "Cancelling…" : "Cancel schedule"}
          </GlobalButton>
        </div>
      }
    >
      <p style={{ fontSize: "0.9375rem", color: "#475569", lineHeight: 1.6 }}>
        Cancel <strong>{schedule?.schedule_title}</strong>? This updates the status to Cancelled.
      </p>
    </GlobalModal>
  );
}
